var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulesAndInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#lrkmvmoixa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25 31c0-.966.784-1.75 1.75-1.75h37c.967 0 1.75.784 1.75 1.75v28.75h-9.8a2.25 2.25 0 0 0-2.25 2.192l-.276 10.808H26A1.75 1.75 0 0 1 24.25 71V31z",
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.718 21.584c.898-1.116 2.287-1.661 3.757-1.634l-1.144.926c-.272.19-.517.408-.707.653-.627.79-.844 1.797-.627 2.859a4.74 4.74 0 0 0 1.716 2.722 4.649 4.649 0 0 0 2.913 1.035c1.116 0 2.15-.463 2.776-1.28.218-.272.354-.544.463-.844l.572-1.198c.327 1.362.082 2.75-.762 3.839-1.634 2.096-5.01 2.205-7.487.245-2.423-1.96-3.104-5.227-1.47-7.323z",
    fill: "#F36E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.61 31.956 2.287-2.178a6.182 6.182 0 0 1-.872-.599 5.887 5.887 0 0 1-.735-.68l-1.933 3.457h1.253z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.661 22.155c1.988 1.552 4.656 1.47 5.962-.19 1.307-1.66.763-4.274-1.197-5.853-1.988-1.552-4.656-1.47-5.962.19-1.307 1.66-.79 4.274 1.197 5.853z",
    fill: "#F36E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.924 21.747c.11-.136.245-.272.382-.408l2.205-1.906a5.368 5.368 0 0 0 1.933 2.967 5.403 5.403 0 0 0 3.24 1.198c-.627 1.307-1.39 2.886-1.552 3.05-1.144 1.442-3.458 1.524-5.173.163-1.715-1.334-2.178-3.594-1.035-5.064z",
    fill: "#F58341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.935 37.401H29.09v9.61h30.845v-9.61zM59.935 49.162H29.09v1.878h30.845v-1.878zM59.935 53.245H29.09v1.879h30.845v-1.879zM43.355 57.33H29.09v1.878h14.265v-1.879zM52.643 73 64.5 60l-9.897.193a2 2 0 0 0-1.96 2V73z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 60 52.805 73V61.898a2 2 0 0 1 2.02-2L65 60z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulesAndInformation);
export default __webpack_public_path__ + "static/media/schedules-and-information.4398a287c99e26767501b169accebe23.svg";
export { ForwardRef as ReactComponent };